import React from 'react'
import PropTypes from 'prop-types'

import Icon from 'components/_new/ui/Icon/Icon'

import s from './ChecklistItem.scss'


const ChecklistItem = ({ children, iconColor }) => (
  <div className={s.item} role="listitem">
    <Icon name="checkmarkLong" color={iconColor} className={s.checkIcon} />
    <div>
      {children}
    </div>
  </div>
)

ChecklistItem.propTypes = {
  children: PropTypes.node.isRequired,
  iconColor: PropTypes.string,
}


export default ChecklistItem
